import { batch, useSignal } from '@preact/signals-react'
import { useCallback, useEffect, useRef } from 'react'
import { getSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'

export default function useRunningScrapersTable() {
    const isLoading = useSignal(true)
    const tableData = useSignal([])
    const isMounted = useRef(true)
    const timeoutId = useRef(null)

    const getData = useCallback(() => {
        const fetchStatus = () => {
            getSubmit(`${BACKEND_APIS.MASTER_DATA}/admin/options/running-scraper-batch-searches`)
                .then(res => {
                    if (isMounted.current) {
                        batch(() => {
                            tableData.value = res
                            isLoading.value = false
                        })
                    }
                })
                .catch(err => console.error(err))
        }

        fetchStatus()

        if (isMounted.current) {
            timeoutId.current = setTimeout(getData, 60000)
        }
    }, [])

    useEffect(() => {
        isMounted.current = true
        getData()
        
        return () => {
            isMounted.current = false
            if (timeoutId.current) {
                clearTimeout(timeoutId.current)
                timeoutId.current = null
            }
        }
    }, [getData])

    return {
        tableData: tableData.value,
        isLoading: isLoading.value,
    }
}